import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import * as classes from './BobActionMenu.module.css';

const ConditionalFormatDropdown = ({
    ...props
}) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickAway = () => {
        setMenuOpen(false);
    };

    const clickOperator = (e,val) => {
        handleClickAway();
        props.updateFormat(val,props.index,'operator');
    };

    const clickBoolean = (e,val) => {
        handleClickAway();
        props.updateFormat(val,props.index,'field1');
    };

    const clickCondition = (e,val) =>{
        handleClickAway();
        props.updateFormat(val,props.index,'condition');
    };

    const getOperatorList = () =>{
        if (props.fieldType === 'numeric') {
            return ['Between','Equals','Greater Than','Less Than'];
        }
        else  if (props.fieldType === 'boolean') {
            return ['Equals','Does not Equal'];
        }
        else  if (props.fieldType === 'date') {
            return ['Between','Equals','Greater Than','Less Than'];
        }
        else  if (props.fieldType === 'string' || props.fieldType === 'text') {
            return ['Contains','Does not contain','Equals','Does not Equal','Starts with','Ends with'];
        }
        else return ['Between','Equals','Greater Than','Less Than'];
    };

    const renderMenu = () => {
        if (props.type === 'operator') {
            const operatorList = getOperatorList(props.fieldType);
            return <Paper className={props.isFromOptimizationReport ? classes.BobActionMenuLeft : classes.BobActionMenu}>
                {operatorList.map((c, index) => 
                    <React.Fragment key={index}>
                        <Button onClick={(e) => clickOperator(e, c)}>
                            {c}
                        </Button>
                    </React.Fragment>             
                )}
            </Paper>;        
        }
        if (props.type === 'boolean') {
            const booleanList = ['True','False'];
            return <Paper className={props.isFromOptimizationReport ? classes.BobActionMenuLeft : classes.BobActionMenu}>
                {booleanList.map((c, index) => 
                    <React.Fragment key={index}>
                        <Button onClick={(e) => clickBoolean(e, c)}>
                            {c}
                        </Button>
                    </React.Fragment>             
                )}
            </Paper>;        
        }
        else if (props.type === 'condition') {
            let greenColor = 'Light Green Fill, Dark Green Text';
            let yellowColor = 'Light Yellow Fill, Dark Yellow Text';
            let greyColor = 'Light Grey Fill, Dark Grey Text';
            let redColor = 'Light Red Fill, Dark Red Text';
            let blueColor = 'Light Blue Fill, Dark Blue Text';

            if (props.isFromOptimizationReport) {
                greenColor = 'Green';
                yellowColor = 'Yellow';
                greyColor = 'Grey';
                redColor = 'Red';
                blueColor = 'Blue';
            }

            return <Paper className={props.isFromOptimizationReport ? classes.BobActionMenuLeft : classes.BobActionMenu}>
                <Button onClick={(e) => clickCondition(e, greenColor)}>
                    <div className="circle-green" >
                        <span className="circle-green-label">A</span>
                    </div>
                    { greenColor }
                </Button>
                <Button onClick={(e) => clickCondition(e, yellowColor)}>
                    <div className="circle-yellow" >
                        <span className="circle-yellow-label">A</span>
                    </div>
                    { yellowColor }
                </Button>
                <Button
                    onClick={(e) => clickCondition(e, greyColor)}
                >
                    <div className="circle-grey" >
                        <span className="circle-grey-label">A</span>
                    </div>
                    { greyColor }
                </Button>
                <Button
                    onClick={(e) => clickCondition(e, redColor)}
                >
                    <div className="circle-red" >
                        <span className="circle-red-label">A</span>
                    </div>
                    { redColor }
                </Button>
                <Button
                    onClick={(e) => clickCondition(e, blueColor)}
                >
                    <div className="circle-blue" >
                        <span className="circle-blue-label">A</span>
                    </div>
                    { blueColor }
                </Button>
            </Paper>;
        }
    };

    const getColor = () => {
        if (!props.val) {
            return '';
        }
        else if (props.val.indexOf('Yellow') !== -1) {
            return 'yellow';
        }
        else if (props.val.indexOf('Green') !== -1) {
            return 'green';
        }
        else if (props.val.indexOf('Grey') !== -1) {
            return 'grey';
        }
        else if (props.val.indexOf('Red') !== -1) {
            return 'red';
        }
        else if (props.val.indexOf('Blue') !== -1) {
            return 'blue';
        }
        else return '';
    };

    return (
        <ClickAwayListener
            onClickAway={() => handleClickAway()}
        >
            <div>
                <React.Fragment>
                    {props.type === 'operator' || props.type === 'boolean' ?
                        <Button
                            onClick={handleToggle}
                            style={{textTransform: 'none !important'}}
                            className={`action-dropdown conditional_dropdown`}
                        >
                            {props.val}
                            <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                        </Button> : ''}
                    {props.type === 'condition' ?
                        <Button
                            onClick={handleToggle}
                            className={`action-dropdown conditional_dropdown condition-dropdown`}
                        >
                            <div className={`circle-${getColor()}`} >
                                <span className={`circle-${getColor()}-label`}> {props.val?'A':''}</span>
                            </div>
                            <span style={{width: 250}}>{props.val}</span>
                            <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                        </Button> : ''}
                    {menuOpen ? renderMenu() : null}
                </React.Fragment>
            </div>
        </ClickAwayListener>
    );
};

export default ConditionalFormatDropdown;
